const alias = 'PRODUCT_COMPARISON';

export const ADD_PRODUCT_COMPARISON_REQUEST = `ADD_${alias}_REQUEST`;
export const ADD_PRODUCT_COMPARISON_SUCCESS = `ADD_${alias}_SUCCESS`;
export const ADD_PRODUCT_COMPARISON_FAILURE = `ADD_${alias}_FAILURE`;
